// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './router'
import { store } from './store'

import Vuetify from 'vuetify'
import VueScrollTo  from 'vue-scrollto'
import VueProgressBar from 'vue-progressbar'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'vuetify/dist/vuetify.min.css'

import axios from 'axios'
// axios.defaults.headers.common['Origin'] = 'http://localhost:8080';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.GET_TOKEN;
// axios.defaults.baseURL = 'http://127.0.0.1:8000';
axios.defaults.baseURL = 'https://tesseract-ics.herokuapp.com';

Vue.use(Vuetify, { 
  theme: { 
    primary: "#43a047", 
    secondary: "#FAFAFA", 
    accent: "#FFC400",
    error: "#f44336", 
    warning: "#ffeb3b", 
    info: "#2196f3", 
    success: "#4caf50" 
}})



Vue.use(VueScrollTo)

Vue.use(VueProgressBar, {
  color: '#ffdc3c',
  thickness: '2px'
})

import 'vue-event-calendar/dist/style.css'
import vueEventCalendar from 'vue-event-calendar'
Vue.use(vueEventCalendar, {
  locale: 'en',
  color: '#43a047'
})

import VueNotifications from 'vue-notifications'
import swal from 'sweetalert'

function toast ({title, message, type, timeout, cb}) {
  if (type === VueNotifications.types.warn) type = 'warning'
  return swal(title, message, type)
}

Vue.use(VueNotifications, {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBm7Pwe3xwVfY_6Yp-ci1nj_xnd7T918M4',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js